var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-splash loading-splash_main"},[_c('div',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }